<template>

	<div class="flip-card" >
		<div class="flip-card-inner" :style="flipCard" >
			
		<div
	
			class="fill-height card flip-card-front"
			@click="$emit('flip')"
		
			
		>
			<img
				v-if="project.img"
				class="info--text align-end"
				:aspect-ratio="1.2"
				width="100%"
				height=100%
				
				:src="'/images/'+ project.img"

			/>
<!-- 	
				<transition name="hover-fade">
					<v-overlay
						v-if="hover"
						absolute
						color="primary"
						opacity="0.8"
					>
						<h1 class="hover-title">
							{{ project.name}}
						</h1>
					</v-overlay>
				</transition> -->
 
				
				
			
			</div>
		

			<div
			
			
				class="fill-height card flip-card-back"
			
				@click="$emit('flip')"
				
			>
			<div class="content">
				<div class="header">
					<h1 class=" primary--text flip-title">
						{{project.name}}
					</h1>
				</div>
				

			
				<!-- <v-btn  outlined small class="flip-btn" color="border" @click.native.once="$emit('flip')" icon>
						<v-icon class="textLight--text flip-icon">mdi-undo</v-icon>
				</v-btn> -->
					
		
		
				<div class=" description">
					<p >
						{{ project.description}}
					</p>
				</div>
				<div class="footer techBackground">
					<v-card-actions>
						<icon
							
							:name="t"
							v-for="t in project.tech"
							:key="t"
							
						/>
					</v-card-actions>
			
	
					<v-spacer></v-spacer>

						<v-tooltip  bottom>
							<template class="icon" v-slot:activator="{ on }">
								
									<v-icon  v-if="project.type == 'solo'" v-on="on" class="techIcon--text icon" small>mdi-account</v-icon>
								
							</template>
							<span>Solo Project</span>
						</v-tooltip>
						<v-tooltip  bottom>
							<template  v-slot:activator="{ on }">

								<v-icon v-if="project.type == 'group'"  v-on="on" class="techIcon--text icon" small>mdi-account-multiple</v-icon>
								
						
							</template>
							<span>Group Project</span>
						</v-tooltip>
						
						<v-tooltip  bottom>
							<template v-slot:activator="{ on }">
								<v-btn  class="icon"  v-if="project.video" v-on="on" :href="project.video" target="_blank" icon>
									<v-icon class="techIcon--text" small>mdi-play</v-icon>
								
								</v-btn>
							</template>
							<span>Video</span>
						</v-tooltip>
						
					
						<v-tooltip  bottom tile>
							<template v-slot:activator="{ on }">
						
								<v-btn  class="icon"  v-if="project.url" v-on="on" :href="project.url" target="_blank" icon>
									<v-icon class="techIcon--text icon"  small>mdi-link</v-icon>
							
								</v-btn>
							</template>
							<span>Learn More</span>
						</v-tooltip>
				
				</div>
		
					
				
			
			</div>
			


				
		
			
			

				
		
			</div>
		
			</div>
	</div>


</template>

<script>
import Icon from "./Icon.vue"

export default {
  name: 'Project',
  props: {
		project: Object,
		flip: Boolean
	},
	components:{
		Icon
	},
	computed:{
		flipCard(){
			if(this.flip){
				return {transform: 'rotateY(180deg)'}
			}
			else{
			
				return {transform: 'rotateY(0)'}
			
			}
		}
	}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.hover-fade-enter-active {
  transition: all .4s ease;
}
.hover-fade-leave-active {
  transition: all .2s ease;
}
.hover-fade-enter, .hover-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.hover-title{
	font-size: 1.5em;
	font-weight: 400;
	word-wrap:none; 
	
}

.flip-title{
	text-transform: uppercase;
    font-weight: 600;
	padding:0.8em; 
    font-size: 0.85em;
	word-wrap:none; 
}
.flip-btn{
	position:absolute;
	right: -1em;  
	top:-1em;
	background:white; 
}

.no-padding{
	padding: 0;
}
.row{
	margin:0;
}
.content{
	height:100%; 
	display:flex;
	flex-direction: column;
	justify-content: space-between;
}

.icon{
	width: 36px; 
	height: 36px;
}
.description {
	flex-grow: 1;
	white-space: pre-line;
	display:block;
	font-size: 0.8em;
	padding: 0px 12px;
	height: 100%;
	overflow-y: auto;
	text-align: left;
}
.footer{ 
	width:100%;
	padding:0.5rem; 
	height: 48px; 
	padding-right: 12px;
	padding-left: 5px;
	display:flex; 
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

}
img{

	width: 100%; 
	height: 18rem;
	
	object-fit: cover; 
	
}
/* .flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
} */
.flip-card{
	background-color: transparent;
	height: 18rem; 
	
	perspective: 1000px; 
}
.flip-card-front:hover, .flip-card-back:hover{
	box-shadow: -2px 10px 10px #919191, 2px 10px 10px #919191;

}

.flip-card-inner{
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
  
}
/* .flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
} */
/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background-color: #bbb;
  color: black;
}

.flip-card-front, .flip-card-back {
	transition: all 300ms ease-in-out;
  position: absolute;
  cursor: pointer; 
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}
/* Style the back side */
.flip-card-back {
  background-color: white;
  transform: rotateY(180deg);
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
